import { createWebSocketStore } from 'src/components/#services/helpers';
export const unsubscribe = createWebSocketStore({
    auth: false,
    requestTemplate: {
        agent: 'user',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'profile_unsubscribeFromNewsletter',
    },
});
